var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4295 32.3404H18.4295V31.3737L17.4633 31.3409L17.4295 32.3404ZM17.4295 41.2798H16.4295V43.694L18.1366 41.9869L17.4295 41.2798ZM26.361 32.3483V31.3483H25.9468L25.6539 31.6412L26.361 32.3483ZM5.26685 18.7158C5.26685 11.7391 10.9226 6.08334 17.8993 6.08334V4.08334C9.81803 4.08334 3.26685 10.6345 3.26685 18.7158H5.26685ZM17.4633 31.3409C10.6888 31.1115 5.26685 25.5466 5.26685 18.7158H3.26685C3.26685 26.6285 9.54721 33.074 17.3956 33.3398L17.4633 31.3409ZM18.4295 41.2798V32.3404H16.4295V41.2798H18.4295ZM25.6539 31.6412L16.7224 40.5727L18.1366 41.9869L27.0681 33.0554L25.6539 31.6412ZM27.301 31.3483H26.361V33.3483H27.301V31.3483ZM39.9335 18.7158C39.9335 25.6925 34.2778 31.3483 27.301 31.3483V33.3483C35.3823 33.3483 41.9335 26.7971 41.9335 18.7158H39.9335ZM27.301 6.08334C34.2778 6.08334 39.9335 11.7391 39.9335 18.7158H41.9335C41.9335 10.6345 35.3823 4.08334 27.301 4.08334V6.08334ZM17.8993 6.08334H27.301V4.08334H17.8993V6.08334Z",
    fill: "black"
  })));
};

export default SvgChat;